import { render, staticRenderFns } from "./sponsor-logo-field.vue?vue&type=template&id=3c2795a8&scoped=true"
import script from "./sponsor-logo-field.vue?vue&type=script&lang=js"
export * from "./sponsor-logo-field.vue?vue&type=script&lang=js"
import style0 from "./sponsor-logo-field.vue?vue&type=style&index=0&id=3c2795a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2795a8",
  null
  
)

export default component.exports